import { render } from "./CustomAlert.vue?vue&type=template&id=5d95bda1&scoped=true"
import script from "./CustomAlert.vue?vue&type=script&lang=js"
export * from "./CustomAlert.vue?vue&type=script&lang=js"

import "./CustomAlert.vue?vue&type=style&index=0&id=5d95bda1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d95bda1"]])

export default __exports__